import { fetchGraphQL, fetchGraphQLv2 } from '../Connections';

import {
  getFieldListString
} from './util';


export function queryListSubscriptions(variables, fields) {
  const query = `
    query listSubscriptions(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $filter_expressions: [FilterExpression],
      $order: Order,
      $orders: [Order],
      $facility_id: String
    ) {
      listSubscriptions(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        filter_expressions: $filter_expressions,
        order: $order,
        orders: $orders,
        facility_id: $facility_id
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}


export function queryGetSubscription(variables, fields) {
  const query = `query getSubscription(
    $subscription_id: String
  ) {
    getSubscription(
      subscription_id: $subscription_id
    ) {
      ${getFieldListString(fields)}
      account_id
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryCreateSubscription(variables, fields) {
  const query = `mutation createSubscription(
    $billing_profile_id: String!,
    $new_payor_password: String,
    $payor: PayorInput!,
    $subscription: SubscriptionInput!
  ) {
    createSubscription(
      billing_profile_id: $billing_profile_id,
      new_payor_password: $new_payor_password,
      payor: $payor,
      subscription: $subscription
    ) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}

export function queryPerformBulkParkerAction(variables, fields) {
  const query = `
    mutation performBulkParkerAction(
      $subscription_id: String!,
      $parker_ids: [String]!,
      $parker_status_history_ids: [String],
      $action: BulkParkerActionEnum!,
      $termination_date: String,
      $suspension_start_date: String,
      $suspension_end_date: String
    ) {
      performBulkParkerAction(
        subscription_id: $subscription_id,
        parker_ids: $parker_ids,
        parker_status_history_ids: $parker_status_history_ids,
        action: $action,
        termination_date: $termination_date,
        suspension_start_date: $suspension_start_date,
        suspension_end_date: $suspension_end_date
      ) {
        ${getFieldListString(fields)}
      }
    }`;

  return fetchGraphQL({ query, variables });
}

export function queryMyProfile(variables, fields) {
  const query = `
  query myProfile(
      $cognitoSub: String!
    ) { 
      myProfile(
        cognitoSub: $cognitoSub
      ) {
        ${getFieldListString(fields)}
      }
    }
  `
  return fetchGraphQL({variables, query})
}

export async function querymakePayment(variables, fields) {
  const query = `
    mutation makePayment(
      $invoice_id: String!,
      $payment_method_id: String!
      $isAdmin: Boolean!
      $allowDuplicate: Boolean!
      $customPaymentAmount: Int
      $paymentMethodStored: Boolean
      $paymentMethodType: String
    ) {
      makePayment(
        invoice_id: $invoice_id,
        payment_method_id: $payment_method_id,
        isAdmin: $isAdmin,
        allowDuplicate: $allowDuplicate,
        customPaymentAmount: $customPaymentAmount,
        paymentMethodStored: $paymentMethodStored,
        paymentMethodType: $paymentMethodType
      ) {
        ${getFieldListString(fields)}
      }
    }`;

  return fetchGraphQL({ query, variables });
}

export async function queryGetCreditCardFeePrice(variables) {
  const query = `
    query getCreditCardFeePrice(
      $billingProfileId: String!,
      $paymentAmount: Int!,
      $numberOfInvoices: Int,
      $subscriptionId: String,
    ) {
      getCreditCardFeePrice(
        billingProfileId: $billingProfileId,
        paymentAmount: $paymentAmount,
        numberOfInvoices: $numberOfInvoices,
        subscriptionId: $subscriptionId
      ) {
        price,
        displayPrice,
        displayPercentage,
        displayDollarAmount,
      }
    }
  `;

  return fetchGraphQLv2({ query, variables });
}


export async function querySaveCreditCard(variables) {
  const query = `
  mutation savePaymentToken($token: GPIInput!, $cognitoSub: String!) { savePaymentToken(gpi_token: $token, cognitoSub: $cognitoSub) }`;

  return fetchGraphQL({ query, variables });
}

export async function querySaveBankAccount(variables) {
  const query = `
  mutation savePaymentToken($gpi_bank_account: GPIBankAccountInput!, $cognitoSub: String!) { savePaymentToken(gpi_bank_account: $gpi_bank_account, cognitoSub: $cognitoSub) }`;

  return fetchGraphQL({ query, variables });
}

export async function queryDeleteCreditCards(variables) {
  const query = `
  mutation deleteCreditCard($cognitoSub: String!, $cardToken: [String]!) { deleteCreditCard(cognitoSub: $cognitoSub, cardToken: $cardToken) }`;

  return fetchGraphQL({ query, variables });
}

export async function queryDeleteBankAccounts(variables) {
  const query = `
  mutation deleteBankAccounts($cognitoSub: String!, $accountTokens: [String]!) { deleteBankAccounts(cognitoSub: $cognitoSub, accountTokens: $accountTokens) }`;

  return fetchGraphQL({ query, variables });
}
